// Phase 31 (C2) — incoming-call ringer. No audio asset exists in the app, so
// the ring is synthesized with the Web Audio API: a 425 Hz tone (the Belgian
// ringback frequency) in a 1 s on / 2 s off cadence. Autoplay policy: an
// AudioContext created before any user gesture starts suspended — we try
// resume() and degrade silently (the visual popup still shows; the next
// gesture lets a later ring sound).

let ctx: AudioContext | null = null;
let interval: ReturnType<typeof setInterval> | null = null;
let active = false;

function beepOnce() {
  if (!ctx || ctx.state !== "running") return;
  try {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "sine";
    osc.frequency.value = 425;
    const t0 = ctx.currentTime;
    // Soft attack/release so the tone doesn't click.
    gain.gain.setValueAtTime(0, t0);
    gain.gain.linearRampToValueAtTime(0.18, t0 + 0.04);
    gain.gain.setValueAtTime(0.18, t0 + 0.92);
    gain.gain.linearRampToValueAtTime(0, t0 + 1.0);
    osc.connect(gain).connect(ctx.destination);
    osc.start(t0);
    osc.stop(t0 + 1.05);
  } catch {
    /* never let the ringer break the popup */
  }
}

export function startRinger() {
  if (active) return;
  active = true;
  try {
    if (!ctx) {
      const AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return;
      ctx = new AC();
    }
    if (ctx.state === "suspended") {
      ctx.resume().catch(() => {});
    }
    beepOnce();
    interval = setInterval(() => {
      if (!active) return;
      if (ctx!.state === "suspended") ctx!.resume().catch(() => {});
      beepOnce();
    }, 3000);
  } catch {
    /* silent degrade */
  }
}

export function stopRinger() {
  active = false;
  if (interval) {
    clearInterval(interval);
    interval = null;
  }
}
